/**
 * @author: Michael 31/8/2018
 * @desc: This is so validation still works where i18n is being used, validation is no longer set in defaultProps but
 * in the state, hence this fallback.
 */
export default function getValidation(component) {
    return component.props.validation || component.state.validation;
}
